import React, { useEffect, useRef, useState } from "react";
import videojs from "video.js";
import "videojs-contrib-quality-levels";
import "../vidjs/videojs.css";
import "videojs-seek-buttons";
import "videojs-landscape-fullscreen";
import { ImgIcons, SVGIcons } from "../../Helpers/Common";
var SVGIcon = "";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export const Demo = () => {
  const videoRef = useRef();
  const [player, setPlayer] = useState(undefined);
  var subtitleCopyArr = [];

  var subtitles = ["https://st1.docubay.com/srt_files/1969081016.vtt"]

  useEffect(() => {
    if (subtitles) {
      if (subtitles.length > 0) {
        for (var i in subtitles) {
          var tempObj = {};
          var tempObj2 = {};
          tempObj["srclang"] = "en";
          tempObj["label"] = "English";
          tempObj["src"] = subtitles[i];
          subtitleCopyArr.push(tempObj);
          tempObj2["srclang"] = "";
          tempObj2["label"] = "Off";
          tempObj2["src"] = "";
        }
        subtitles.push(tempObj2, ...subtitleCopyArr);
      }
    }
    var videoJsOptions = {
      html5: {
        hls: {
          overrideNative: true,
          nativeControlsForTouch: true,
        },
        nativeTextTracks: false,
      },
      hls: {
        withCredentials: false,
      },
      controlBar: {
        muteToggle: false,
        fullscreenToggle: true,
        volumePanel: {
          inline: false,
          volumeControl: {
            vertical: true,
          },
        },
      },
      fullscreen: {
        enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
        alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
        iOS: false, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
      },
      autoplay: true,
      kind: "captions",
      preload: "auto",
      aspectRatio: "15:12",
      textTrackSettings: false,
      height: "100%",
      width: "100%",
      fluid: true,
      tracks: subtitles,
      nativeControlsForTouch: false,
      responsive: true,
      qualityMenu: {
        useResolutionLabels: true,
      },
      controls: true,
      fullscreen: [
        {
          enterOnRotate: true, // Enter fullscreen mode on rotating the device in landscape
          alwaysInLandscapeMode: true, // Always enter fullscreen in landscape mode even when device is in portrait mode (works on chromium, firefox, and ie >= 11)
          iOS: true, //Whether to use fake fullscreen on iOS (needed for displaying player controls instead of system controls)
        },
      ],
      playbackRates: [0.5, 0.75, 1, 1.5, 2, 3],
      sources: [
        {
          // src: "https://docubayvod.s.llnwi.net/mmd-video/DBvideo/plastic-fantastic-test-3/stream.ismd/manifest.m3u8?stream=480p;720p;1080p&s=1701162930&e=1702458930&h=dad8b6c84a85a0003e0e58139b7ffab9&hls_force_no_caption_tag=true",
          src: "https://docubayvod.s.llnwi.net/mmd-video/DBvideo/aadhaar-test/stream.ismd/manifest.m3u8?stream=480p;144p;240p;1080p;2160p;320p;720p;1440p&s=1714633925&e=1715929925&h=b19972ca6cd19c3871a017ef849ae246&hls_force_no_caption_tag=true",
          // type: "application/x-mpegURL",
        },
      ],
    };
    const p = videojs(videoRef.current, videoJsOptions);

    if (typeof player !== "undefined") {
      p.muted(false);
      player.hlsQualitySelector({ displayCurrentQuality: true, iOS: true });
      let qualityLevels = player.qualityLevels();
      qualityLevels.on("addqualitylevel", function (event) {
        let qualityLevel = event.qualityLevel;
        if (qualityLevel.height) {
          qualityLevel.enabled = true;
        } else {
          qualityLevels.removeQualityLevel(qualityLevel);
          qualityLevel.enabled = false;
        }
      });

      //   var myButton = p.controlBar.addChild("button", {});
      //   myButton.addClass("vjs-close-button");
      //   var myButtonDom = myButton.el();

      //   myButtonDom.innerHTML =
      //     '<img src="' + SVGIcon["search-close.svg"] + '" alt="Sign up" />';
      //   myButton.on(["tap", "click"], myfun);

      //   function myfun() {
      //     var CurrentTime = player.currentTime();
      //     window.location.href("/")
      //   }

      var backwordbtn = p.controlBar.addChild("button", {});
      backwordbtn.addClass("prevbtn");
      var backwordbtnDom1 = backwordbtn.el();

      backwordbtnDom1.innerHTML =
        '<span  class="player__button prevbtn show-backward"><img src="' +
        SVGIcon["Reload-Backward.svg"] +
        '" class="backward_player"><span class="hovereffetc"></span</span>';

      backwordbtn.on(["tap", "click"], backforward);

      function backforward() {
        var value = eval(player.currentTime() - 10);
        if (Math.sign(value) != -1) player.currentTime(value);
      }

      var forwordbtn = p.controlBar.addChild("button", {});
      forwordbtn.addClass("nextbtn");
      var forwordbtnDom1 = forwordbtn.el();
      forwordbtnDom1.innerHTML =
        '<span  class="player__button nextbtn"><img src="' +
        SVGIcon["Reload-Forward.svg"] +
        '" class="forward_player"><span class="hovereffetc"></span</span>';
      forwordbtn.on(["tap", "click"], seekforward);
      function seekforward() {
        var value = eval(player.currentTime() + 10);
        if (Math.sign(value) != -1) player.currentTime(value);
      }
    }
    setPlayer(p);

    return () => {
      if (player) player.dispose();
    };
  }, [player]);
  return (
    <div className="playtrailer">
      <video
        ref={videoRef}
        className="vidPlayer video-js vjs-default-skin vjs-big-play-centered"
        style={{ height: "100vh", width: "100%", background: "#000" }}
        autoPlay
        muted
        controls
        playsInline={true}
      ></video>
    </div>
  );
};
